import { HydratedChatbotWithFolder } from "./useChatbotsList";
import { useState } from "react";
import { ChatbotModal } from "./ChatbotsTable/ChatbotModals";
import { HydratedChatbotAsset } from "@zapier/bff";

export function useChatbotModalStates() {
  const [currentModal, setCurrentModal] = useState<ChatbotModal | undefined>();
  const [currentChatbot, setCurrentChatbot] = useState<
    HydratedChatbotWithFolder | HydratedChatbotAsset | undefined
  >();
  return {
    currentModal,
    currentChatbot,
    setCurrentModal,
    setCurrentChatbot,
  };
}
